import React from 'react';
import PageBanner from '../components/PageBanner';

const SECTIONS = [
  {
    title: '1. قبول الشروط',
    body: 'باستخدامك لموقع أو تطبيق MEME STORE فإنك توافق على الالتزام بهذه الشروط والأحكام بالكامل. إذا كنت لا توافق على أي جزء منها، يرجى عدم استخدام خدماتنا.',
  },
  {
    title: '2. الحسابات والتسجيل',
    body: 'يجب تقديم بيانات صحيحة ودقيقة عند إنشاء حسابك، وأنت مسؤول عن الحفاظ على سرية بيانات الدخول وعن كل النشاط الذي يتم من خلال حسابك.',
  },
  {
    title: '3. الطلبات والأسعار',
    body: 'نسعى لعرض أسعار ووصف دقيق للمنتجات، لكن قد تحدث أخطاء أحياناً. نحتفظ بحق تعديل أو إلغاء أي طلب يحتوي على خطأ في السعر أو التوفر قبل الشحن، مع إبلاغك بذلك.',
  },
  {
    title: '4. الدفع',
    body: 'نوفر عدة وسائل دفع تشمل الدفع الإلكتروني والدفع عند الاستلام حسب المنطقة. جميع المعاملات الإلكترونية تتم عبر بوابات دفع آمنة ومشفرة.',
  },
  {
    title: '5. الشحن والتوصيل',
    body: 'مدة التوصيل تقديرية وقد تختلف حسب المنطقة والظروف التشغيلية. لمزيد من التفاصيل راجع صفحة سياسة الشحن والتوصيل.',
  },
  {
    title: '6. الإرجاع والاستبدال',
    body: 'يحق للعميل طلب إرجاع أو استبدال المنتج خلال المدة المحددة في سياسة الإرجاع، بشرط أن يكون المنتج بحالته الأصلية.',
  },
  {
    title: '7. الملكية الفكرية',
    body: 'جميع المحتويات الموجودة على المنصة، من شعارات وتصاميم ونصوص وصور، مملوكة لـ MEME STORE ولا يجوز استخدامها دون إذن كتابي مسبق.',
  },
  {
    title: '8. التعديلات على الشروط',
    body: 'قد نقوم بتحديث هذه الشروط من وقت لآخر، وسيتم نشر أي تعديل على هذه الصفحة مع تاريخ آخر تحديث.',
  },
];

const TermsAndConditions = () => {
  return (
    <div dir="rtl">
      <PageBanner
        eyebrow="آخر تحديث: يوليو 2026"
        title="الشروط والأحكام"
        subtitle="يرجى قراءة هذه الشروط بعناية قبل استخدام موقع أو تطبيق MEME STORE."
      />

      <div className="container mx-auto px-4 py-14 max-w-3xl">
        <div className="space-y-8">
          {SECTIONS.map((section) => (
            <div key={section.title}>
              <h2 className="text-lg font-bold text-[#1B1B1F] mb-2">{section.title}</h2>
              <p className="text-gray-600 leading-8">{section.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 bg-[#F6F5F2] rounded-2xl text-sm text-gray-600 leading-7">
          لو عندك أي استفسار عن الشروط والأحكام، تقدر تتواصل معانا من صفحة{' '}
          <a href="/contact-us" className="text-[#1B1B1F] font-bold underline decoration-[#F2B705]">
            اتصل بنا
          </a>
          .
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
